import { get } from 'common/utils/xhr';
import createScrollableElements, { centerAlignScrollableElement, scrollOnHover } from 'marketing/components/scrollable';
import { findParentByAttribute } from 'common/utils/domUtils';
import FullscreenOverlay from 'marketing/components/FullscreenOverlay';

export default class LogoDesignInspiration {
    constructor() {
        this.allDesignsContainer = document.querySelector('[data-logo-inspiration-designs]');
        this.loading = document.querySelector('[data-logo-inspiration-designs-loading]');
        this.showAll = 'false';
        this.fullscreenOverlayElement = document.querySelector('[data-fullscreen-overlay-id="logo-design-inspiration-modal"]');

        this.initialise();
        this.getDesignsByIndustry();
    }

    initialise() {
        let extraDesigns = document.querySelector('[data-extra-inspiration-designs]');
        let showMoreButton = document.querySelector('[data-extra-inspiration-button]');
        let discoverLink = document.querySelector('[data-extra-inspiration-discover-link]');
        let designs = this.allDesignsContainer.querySelectorAll('[data-fullscreen-overlay-open]');

        this.initialiseFullScreenOverlay();

        showMoreButton.addEventListener('click', () => {
            showMoreButton.setAttribute('data-hidden', true);
            extraDesigns.removeAttribute('data-hidden');
            discoverLink.removeAttribute('data-hidden');
            this.showAll = 'true';
        });

        for (const design of designs) {
            design.addEventListener('click', () => {
                this.setModalContent(design);
            });
        }
    }

    initialiseFullScreenOverlay() {
        new FullscreenOverlay({
            element: this.fullscreenOverlayElement,
            options: {
                fixedViewport: true
            }
        });
    }

    getDesignsByIndustry() {
        const industrySelect = document.getElementById('logo-design-inspiration-industry-select');


        industrySelect.addEventListener('change', (e) => {
            this.startLoading();

            const xhr = get(`/start/xhr/inspiration-designs/${e.target.value}?show_all=${this.showAll}`);
            xhr.end((error, res) => {
                if (error) {
                    this.stopLoading();
                } else {
                    this.allDesignsContainer.innerHTML = res.body.html;
                    this.initialise();
                    this.runScrollable();
                    this.stopLoading();
                }
            });
        });
    }

    setModalContent(design) {
        const modalElement = this.fullscreenOverlayElement.querySelector('[data-fullscreen-overlay-modal-content]');
        const modalContentContainer = design.querySelector('[data-modal-content-container]');
        const modalImageElement = modalContentContainer.querySelector('[data-modal-image]');
        const modalImageSrc = modalImageElement.getAttribute('data-image-src');

        modalImageElement.setAttribute('src', modalImageSrc);
        modalElement.innerHTML = modalContentContainer.innerHTML;
    }

    startLoading() {
        this.loading.removeAttribute('data-hidden');
    }

    stopLoading() {
        this.loading.setAttribute('data-hidden', '');
    }

    runScrollable() {
        createScrollableElements();
        scrollOnHover('[data-scrollable="examples"]');
        centerAlignScrollableElement('[data-scrollable="examples"]')
    }

    getDefaultTrackingData(node) {
        const globalTrackParams = global.trackParams || {};
        const parent = findParentByAttribute(node, 'data-trackable-section');
        const sectionId = parent ? parent.getAttribute('data-trackable-section') : null;

        return Object.assign({}, global.trackParams, {
            section_id: sectionId,
        });
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/LogoDesignInspiration.js